<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :show-message="showMessage"
    >
      <!-- inline-message -->
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_vessel') || '船名'"
            prop="vessel"
          >
            <el-input
              v-model.trim="formData.vessel"
              :placeholder="
                $l('INDEX.form_placeholder_vessel') || '请选择输入船名'
              "
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_voyage') || '航次'"
            prop="voyage"
          >
            <el-input
              v-model.trim="formData.voyage"
              :placeholder="
                $l('INDEX.form_placeholder_voyage') || '请选择输入航次'
              "
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('INDEX.form_isSingleNo') || '是否多单号'">
            <el-checkbox
              style="width:100%"
              v-model="formData.isSingleNo"
              :label="$l('INDEX.yes_no') || '是/否'"
              border
            ></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('INDEX.form_bookingNo') || '订舱单号'"
            prop="bookingNo"
          >
            <el-input
              v-model.trim="formData.bookingNo"
              :placeholder="
                $l('INDEX.form_placeholder_bookingNo') || '请输入订舱单号'
              "
              clearable
              :disabled="isSingleNo"
              @blur="onBookingNoBlur"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('INDEX.form_customsNo') || '关单号'"
            prop="customsNo"
          >
            <el-input
              v-model.trim="formData.customsNo"
              :placeholder="
                $l('INDEX.form_placeholder_customsNo') || '请输入关单号'
              "
              clearable
              :disabled="isSingleNo"
              @blur="onCustomsNoBlur"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_bookingDate') || '订舱日期'"
            prop="bookingDate"
          >
            <el-date-picker
              v-model="formData.bookingDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_placeholder_bookingDate') || '请选择订舱日期'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_docCutOffDate') || '截单日期'"
            prop="docCutOffDate"
          >
            <el-date-picker
              v-model="formData.docCutOffDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_placeholder_docCutOffDate') || '请选择截单日期'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_closingDate') || '开船日期'"
          >
            <el-date-picker
              v-model="formData.closingDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_placeholder_closingDate') || '请选择开船日期'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_ETA') || '到港日期'" >
            <el-date-picker
              v-model="formData.eta"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_placeholder_EAT') || '请选择到港日期'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ContainerBookingTable
          :shipmentCode="shipmentCode"
          :disabled="!isSingleNo"
          ref="containerBookingTable"
          @editClosed="editClosed"
        />
      </el-row>
      <el-row>
        <ContainerTable :shipmentCode="shipmentCode" ref="containerTable" />
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ContainerBookingTable from '../container-booking'
import ContainerTable from '../container'
export default {
  mixins: [EditLoading],
  components: { ContainerBookingTable, ContainerTable },
  props: {
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      showMessage: false,
      rules: {
        vessel: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_vessel') || '请选择输入船名',
            trigger: 'blur',
          },
        ],
        voyage: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_voyage') || '请选择输入航次',
            trigger: 'blur',
          },
        ],
        bookingNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_bookingNo') || '请输入订舱单号',
            trigger: 'blur',
          },
        ],
        customsNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_customsNo') || '请输入关单号',
            trigger: 'blur',
          },
        ],
        bookingDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_bookingDate') || '请选择订舱日期',
            trigger: 'change',
          },
        ],
        docCutOffDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_docCutOffDate') ||
              '请选择截单日期',
            trigger: 'change',
          },
        ],
        plannedETD: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_plannedETD') ||
              '请选择计划发运日期',
            trigger: 'change',
          },
        ],
        actualETD: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_actualETD') ||
              '请选择实际发运日期',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    isSingleNo() {
      const { isSingleNo } = this.formData
      if (isSingleNo === 'Y') return true
      if (isSingleNo === 'N') return false
      return !!isSingleNo
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.shipmentCode) return
      this.showMessage = false
      this.$api
        .shipmentBookingInfoApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.formData = res.body

          const { isSingleNo } = this.formData
          this.formData.isSingleNo = isSingleNo === 'Y'
          setTimeout(() => {
            this.showMessage = true
            this.$refs.form.clearValidate()
          }, 1000)
        })
        .catch(() => {
          setTimeout(() => {
            this.showMessage = true
            this.$refs.form.clearValidate()
          }, 1000)
        })
    },
    async save() {
      const result = await this.validateData()
      if (!result) return

      const { isSingleNo } = this.formData
      this.formData.isSingleNo = isSingleNo ? 'Y' : 'N'

      const listContainerBooking = this.$refs.containerBookingTable.getTableData()
      const listContainer = this.$refs.containerTable.getTableData()
      const params = { listContainer, listContainerBooking, ...this.formData }

      this.loadingOpen()
      this.$api
        .shipmentUpdateBookingInfoApi(params)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async validateData() {
      const formResult = await validate.formValidate([this.$refs.form])
      const containerBookingResult = await this.$refs.containerBookingTable.validate()
      const containrResult = await this.$refs.containerTable.validate()
      return formResult && containerBookingResult && containrResult
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
    },
    editClosed({ bookingNo, customsNo }) {
      this.formData.bookingNo = bookingNo
      this.formData.customsNo = customsNo
    },
    onBookingNoBlur() {
      this.$refs.containerBookingTable.updateBookingNo(this.formData.bookingNo)
    },
    onCustomsNoBlur() {
      this.$refs.containerBookingTable.updateCustomsNo(this.formData.customsNo)
    },
  },
}
</script>
